module.exports = __webpack_public_path__ + "img/trans - Copy.3409cdc7.png";